import React from 'react';

export const CosmicBackground = () => {
  return (
    <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden bg-[#090a0f] dark-cosmic-bg">
      <div 
        className="absolute -top-[20%] -left-[10%] w-[650px] h-[650px] rounded-full blur-[140px] opacity-25"
        style={{ background: 'radial-gradient(circle, #3b82f6, #1e293b, transparent)' }}
      />
      <div 
        className="absolute -bottom-[20%] -right-[10%] w-[650px] h-[650px] rounded-full blur-[150px] opacity-20"
        style={{ background: 'radial-gradient(circle, #1d4ed8, #0f172a, transparent)' }}
      />
      <div 
        className="absolute top-[40%] left-[30%] w-[450px] h-[450px] rounded-full blur-[160px] opacity-15"
        style={{ background: 'radial-gradient(circle, #60a5fa, transparent)' }}
      />
      <div 
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: 'linear-gradient(rgba(255, 255, 255, 0.12) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.12) 1px, transparent 1px)',
          backgroundSize: '40px 40px'
        }}
      />
    </div>
  );
};

export default CosmicBackground;
